import * as React from "react";

import { PpqCovid19Outcome } from "../models";

export class PpqCovid19OutcomeSection extends React.Component<PpqCovid19Outcome> {
    public render() {
        return (
            <>
                <br />
                {this.props.covidFinalRiskGroup === "Very High" &&
                <>
                    Individuals in this category are at greatest risk of severe illness from COVID-19.
                    <br />
                    <br />
                    Our advice is that the individual should not work in areas of high COVID-19 transmission risk.
                    This will include working in rooms, wards or vehicles that involves close proximity or delivering care
                    to known COVID-19 positive patients or working with people who are likely to be infected with COVID-19
                    (such as testing symptomatic staff). Exposure to any kind of aerosol generating procedures should also be avoided.
                    <br />
                    <br />
                    Managers should consider the following adjustments:
                    <ul>
                        <li>Moving the staff member to a lower risk/COVID-19 safe area with appropriate
                            support and mitigation measures in place</li>
                        <li>Conducting work using online video or telephone meetings or appointments where possible</li>
                        <li>Home working if possible</li>
                        <li>Taking steps to reducing the likelihood of anyone breaching social distancing in the place of work</li>
                        <li>Providing additional high levels of PPE in the workplace</li>
                        <li>If the role requires the use of PPE take additional measures to ensure that it can be worn
                            at all times</li>
                        <li>Providing additional or higher levels of PPE where moving the staff member to lower risk areas
                            is not possible</li>
                    </ul>
                    <br />
                    Managers may also wish to discuss the outcome of this assessment with Occupational
                    Health or make a formal referral for more advice.
                    <br />
                    <br />
                    Individuals in this category may have also been identified by the NHS as Clinical
                    Extremely Vulnerable (CEV) and their manager should
                    undertake an urgent review of this risk assessment should there be any change
                    in government guidelines for individuals identified as CEV.
                </>
                }
                {this.props.covidFinalRiskGroup === "High" &&
                <>
                    Individuals in this category are at a significantly elevated risk of severe illness from COVID-19.
                    <br />
                    <br />
                    Our advice is that if possible the individual should not work in areas of high COVID-19 transmission risk.
                    This will include working in rooms, wards or vehicles that involve close proximity or delivering care to
                    known COVID-19 positive patients or working with people who are likely to be infected with COVID-19 (such as testing
                    symptomatic staff). Exposure to any kind of aerosol generating procedures should also be avoided if possible.
                    <br />
                    <br />
                    Managers should consider the following adjustments:
                    <ul>
                        <li>Moving the staff member to a lower risk/COVID-19 safe area with appropriate support and
                            mitigation measures in place</li>
                        <li>Conducting work using online video or telephone meetings or appointments where possible</li>
                        <li>Home working if possible</li>
                        <li>Where it is not possible to remove the individual from high risk areas the following adjustments
                            are recommended for consideration</li>
                    </ul>
                    <br />
                    Where it is not possible to remove the individual from high risk areas the following
                    adjustments are recommended for consideration
                    <br />
                    <br />
                    <ul>
                        <li>Taking additional steps to reduce the likelihood of anyone breaching social distancing
                            in the place of work</li>
                        <li>If the role requires the use of PPE take additional measures to ensure that it can be
                            worn at all times</li>
                        <li>Providing additional or higher levels of PPE where moving the staff member to lower risk
                            areas is not possible</li>
                        <li>If there are particular tasks or procedures where social distancing is compromised
                            consider if it is possible to remove the individual from these specific tasks</li>
                    </ul>
                    <br />
                    Managers may also wish to discuss the outcome of this assessment with Occupational Health
                    or make a formal referral for more advice.
                    <br />
                    <br />
                    Individuals in this category may have also been identified by the NHS as Clinical
                    Extremely Vulnerable (CEV) and their manager should undertake an urgent review of
                    this risk assessment should there be any change in government guidelines for
                    individuals identified as CEV.
                </>
                }
                {this.props.covidFinalRiskGroup === "Moderate" &&
                <>
                    Individuals in this category are at moderate risk of severe illness from COVID-19.
                    <br />
                    <br />
                    There will not normally be any requirement for any additional adjustments or controls to be put in place over
                    and above standard workplace measures that need to be adopted by all individuals. These standard
                    measures will be dictated by current government guidelines and the outcome from any workplace risk
                    assessments that have been completed by the employer.
                    <br />
                    <br />
                </>
                }
                {this.props.covidFinalRiskGroup === "Low" &&
                <>
                    Individuals in this category are at low risk of severe illness from COVID-19.
                    <br />
                    <br />
                    There is no requirement for any additional adjustments or controls to be put in place over and above standard
                    workplace measures that need to be adopted by all individuals. These standard measures will be dictated by
                    current government guidelines and the outcome from any workplace risk assessments that have been completed
                    by the employer.
                    <br />
                    <br />
                </>
                }
            </>
        );
    }
}
